import type { AdminUserFilters } from '../model/types'

export const adminUserKeys = {
  all: ['admin-users'] as const,
  list: (filters?: AdminUserFilters) =>
    filters === undefined
      ? ([...adminUserKeys.all, 'list'] as const)
      : ([...adminUserKeys.all, 'list', filters] as const),
  detail: (id: string) => [...adminUserKeys.all, 'detail', id] as const,
  sessions: (id: string) => [...adminUserKeys.all, 'sessions', id] as const,
  audit: (id: string, page: number) => [...adminUserKeys.all, 'audit', id, page] as const,
}
